(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ec-cart-redirect"]) return;
  try {
    
  (function () {
    const drawer = document.getElementById('ec-cart-drawer');
    const shopUrl = drawer?.dataset?.shopKitsUrl || '/';
    const cartOpenParam = 'open_cart';

    const resolveReturnUrl = () => {
      const referrer = document.referrer;
      let target = new URL(shopUrl, window.location.origin);

      if (referrer) {
        try {
          const refUrl = new URL(referrer);
          if (refUrl.origin === window.location.origin && !refUrl.pathname.endsWith('/cart')) {
            target = refUrl;
          }
        } catch (error) {
          /* ignore */
        }
      }

      target.searchParams.set(cartOpenParam, '1');
      return target.toString();
    };

    window.location.replace(resolveReturnUrl());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-cart"]) return;
  try {
    
  const cartSection = document.querySelector('.ec-cart');
  if (!cartSection) return;

  const summary = cartSection.querySelector('[data-ec-cart-summary]');
  const summaryToggle = cartSection.querySelector('[data-ec-cart-summary-toggle]');

  summaryToggle?.addEventListener('click', () => {
    if (!summary) return;
    summary.classList.toggle('is-collapsed');
    const expanded = !summary.classList.contains('is-collapsed');
    summaryToggle.setAttribute('aria-expanded', String(expanded));
    summaryToggle.setAttribute(
      'aria-label',
      expanded
        ? summaryToggle.dataset.hideSummary || 'Hide summary'
        : summaryToggle.dataset.showSummary || 'Show summary'
    );
  });

  cartSection.querySelectorAll('[data-ec-cart-quantity]').forEach((wrap) => {
    const input = wrap.querySelector('[data-ec-cart-qty-input]');
    const decrease = wrap.querySelector('[data-ec-cart-qty-decrease]');
    const increase = wrap.querySelector('[data-ec-cart-qty-increase]');

    decrease?.addEventListener('click', () => {
      const current = parseInt(input.value, 10) || 0;
      input.value = Math.max(0, current - 1);
    });

    increase?.addEventListener('click', () => {
      const current = parseInt(input.value, 10) || 0;
      input.value = current + 1;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-customers"]) return;
  try {
    
  const customersSection = document.querySelector('.ec-customers');
  if (!customersSection) return;

  const loginPanel = customersSection.querySelector('[data-ec-login-panel]');
  const recoverPanel = customersSection.querySelector('[data-ec-recover-panel]');
  const showRecover = customersSection.querySelector('[data-ec-show-recover]');
  const showLogin = customersSection.querySelector('[data-ec-show-login]');

  showRecover?.addEventListener('click', () => {
    loginPanel.hidden = true;
    recoverPanel.hidden = false;
  });

  showLogin?.addEventListener('click', () => {
    recoverPanel.hidden = true;
    loginPanel.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-drop-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ec-drop-slider]').forEach((section) => {
    const viewport = section.querySelector('[data-ec-drop-marquee]');
    const track = section.querySelector('[data-ec-drop-track]');
    const prevButton = section.querySelector('[data-ec-drop-prev]');
    const nextButton = section.querySelector('[data-ec-drop-next]');
    const dots = [...section.querySelectorAll('[data-ec-drop-dot]')];

    const originalCount = Number(section.dataset.ecDropCount) || dots.length || 0;

    if (!viewport || !track || originalCount === 0) return;

    const passVerticalScrollToPage = (event) => {
      const deltaY = event.deltaY;
      const deltaX = event.deltaX;

      if (Math.abs(deltaY) <= Math.abs(deltaX) || deltaY === 0) return;

      event.preventDefault();
      window.scrollBy({
        top: deltaY,
        left: 0,
        behavior: 'auto',
      });
    };

    section.addEventListener('wheel', passVerticalScrollToPage, { passive: false, capture: true });

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const FLAT_GALLERY_SCROLL_IDLE_MS = 220;
    const FLAT_GALLERY_TOUCH_IDLE_MS = 320;
    const MANUAL_SCROLL_MIN_MS = 480;
    const MANUAL_SCROLL_MAX_MS = 960;
    const getBaseAutoScrollSpeed = () => Math.max(1.3, viewport.clientWidth / 1200);
    const AUTO_SCROLL_RAMP_MS = 7000;
    const INITIAL_AUTO_SCROLL_RATIO = 0.38;
    const RESUME_DELAY_MS = 1000;

    let autoScrollActive = false;
    let autoScrollTick = false;
    let autoScrollStartedAt = 0;
    let isInitialAutoScroll = true;
    let rafId = null;
    let resumeTimeout = null;
    let userScrollIdleTimeout = null;
    let isInitializing = true;
    let isLoopAdjusting = false;
    let isHovered = false;
    let isPointerActive = false;
    let isTouchActive = false;
    let isUserScrolling = false;
    let pendingDrag = false;
    let isDragging = false;
    let dragStartX = 0;
    let dragScrollLeft = 0;
    let dragDistance = 0;
    let activePointerId = null;
    let autoScrollTargetIndex = null;
    let isAutoScrollMoving = false;
    let programmaticScrollDepth = 0;
    let suppressUserScrollUntil = 0;
    let isSmoothSnapping = false;
    let smoothScrollRaf = null;
    let momentumRaf = null;
    let isMomentumScrolling = false;
    let dragVelocity = 0;
    let lastDragX = 0;
    let lastDragTime = 0;

    const cancelManualScrollAnimations = () => {
      if (smoothScrollRaf) {
        cancelAnimationFrame(smoothScrollRaf);
        smoothScrollRaf = null;
      }

      if (momentumRaf) {
        cancelAnimationFrame(momentumRaf);
        momentumRaf = null;
      }

      isSmoothSnapping = false;
      isMomentumScrolling = false;
      viewport.classList.remove('is-smooth-scrolling');
    };

    const easeOutQuart = (progress) => 1 - Math.pow(1 - progress, 4);

    const getManualScrollDuration = (distance) =>
      Math.min(MANUAL_SCROLL_MAX_MS, Math.max(MANUAL_SCROLL_MIN_MS, Math.abs(distance) * 0.95));

    const animateScrollTo = (targetLeft, onComplete) => {
      cancelManualScrollAnimations();

      const startLeft = viewport.scrollLeft;
      const distance = targetLeft - startLeft;

      if (Math.abs(distance) < 0.5) {
        onComplete?.();
        return;
      }

      isSmoothSnapping = true;
      viewport.classList.add('is-user-scrolling', 'is-smooth-scrolling');
      const startTime = performance.now();
      const duration = getManualScrollDuration(distance);

      const step = (now) => {
        const progress = Math.min(1, (now - startTime) / duration);
        const eased = easeOutQuart(progress);
        viewport.scrollLeft = startLeft + distance * eased;

        if (progress < 1) {
          smoothScrollRaf = requestAnimationFrame(step);
          return;
        }

        smoothScrollRaf = null;
        isSmoothSnapping = false;
        viewport.classList.remove('is-smooth-scrolling');
        adjustScrollLoopIfNeeded();
        onComplete?.();
      };

      smoothScrollRaf = requestAnimationFrame(step);
    };

    const releaseDragMomentum = () => {
      cancelManualScrollAnimations();

      let velocity = -dragVelocity * 22;

      isMomentumScrolling = true;
      viewport.classList.add('is-user-scrolling');

      const step = () => {
        if (Math.abs(velocity) < 0.25) {
          momentumRaf = null;
          isMomentumScrolling = false;
          settleAfterUserScroll();
          return;
        }

        viewport.scrollLeft += velocity;
        velocity *= 0.935;
        adjustScrollLoopIfNeeded();
        momentumRaf = requestAnimationFrame(step);
      };

      if (Math.abs(dragVelocity) > 0.012 && !prefersReducedMotion) {
        momentumRaf = requestAnimationFrame(step);
        return;
      }

      isMomentumScrolling = false;
      settleAfterUserScroll();
    };

    const getAutoScrollSpeed = () => {
      const baseSpeed = getBaseAutoScrollSpeed();

      if (!isInitialAutoScroll || !autoScrollStartedAt) return baseSpeed;

      const elapsed = performance.now() - autoScrollStartedAt;
      const progress = Math.min(1, elapsed / AUTO_SCROLL_RAMP_MS);
      const eased = progress * progress;
      const multiplier = INITIAL_AUTO_SCROLL_RATIO + (1 - INITIAL_AUTO_SCROLL_RATIO) * eased;

      if (progress >= 1) {
        isInitialAutoScroll = false;
      }

      return baseSpeed * multiplier;
    };

    const markInitialAutoScrollComplete = () => {
      isInitialAutoScroll = false;
      autoScrollStartedAt = 0;
    };

    const runProgrammaticScroll = (updateScroll) => {
      programmaticScrollDepth += 1;
      autoScrollTick = true;
      suppressUserScrollUntil = performance.now() + 64;
      updateScroll();
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          programmaticScrollDepth = Math.max(0, programmaticScrollDepth - 1);
          if (programmaticScrollDepth === 0) {
            autoScrollTick = false;
          }
          suppressUserScrollUntil = performance.now() + 64;
        });
      });
    };

    const isProgrammaticScroll = () =>
      programmaticScrollDepth > 0 ||
      autoScrollTick ||
      isLoopAdjusting ||
      isAutoScrollMoving ||
      performance.now() < suppressUserScrollUntil;

    const getItems = () => [...track.querySelectorAll('.ec-drop-slider__item')];

    const getRealSetStartIndex = () => (originalCount > 1 ? originalCount * 2 : 0);

    const getRealSetEndIndex = () => getRealSetStartIndex() + originalCount;

    const isInRealZone = (index) => {
      const realStart = getRealSetStartIndex();
      return index >= realStart && index < realStart + originalCount;
    };

    const normalizeItemIndex = (index) => {
      const realStart = getRealSetStartIndex();

      if (index < realStart) {
        const setsForward = Math.ceil((realStart - index) / originalCount);
        return index + setsForward * originalCount;
      }

      if (index >= realStart + originalCount) {
        const setsBack = Math.floor((index - realStart) / originalCount);
        return index - setsBack * originalCount;
      }

      return index;
    };

    const getSetWidth = () => {
      const items = getItems();
      if (originalCount <= 1 || items.length < originalCount * 2) return 0;

      const realStartIndex = getRealSetStartIndex();
      const realStart = items[realStartIndex];
      const realEnd = items[realStartIndex + originalCount];
      if (!realStart || !realEnd) return 0;

      return realEnd.offsetLeft - realStart.offsetLeft;
    };

    const getTrailEndOffset = () => {
      const items = getItems();
      const lastItem = items[items.length - 1];
      if (!lastItem) return 0;

      return lastItem.offsetLeft + lastItem.offsetWidth;
    };

    const getRealSetStartOffset = () => {
      const items = getItems();
      const realStart = items[getRealSetStartIndex()];
      return realStart ? realStart.offsetLeft : 0;
    };

    const getItemStep = () => {
      const items = getItems();
      if (items.length < 2) return 0;

      const first = items[getRealSetStartIndex()];
      const second = items[getRealSetStartIndex() + 1];
      if (!first || !second) return items[1].offsetLeft - items[0].offsetLeft;

      return second.offsetLeft - first.offsetLeft;
    };

    const getClosestItemIndex = () => {
      const items = getItems();
      if (!items.length) return 0;

      const viewportRect = viewport.getBoundingClientRect();
      const viewportCenter = viewportRect.left + viewportRect.width / 2;
      let closest = 0;
      let minDist = Infinity;

      items.forEach((item, index) => {
        const itemRect = item.getBoundingClientRect();
        const itemCenter = itemRect.left + itemRect.width / 2;
        const dist = Math.abs(itemCenter - viewportCenter);
        if (dist < minDist) {
          minDist = dist;
          closest = index;
        }
      });

      return closest;
    };

    const getCenterDelta = (index) => {
      const items = getItems();
      const item = items[index];
      if (!item) return 0;

      const viewportRect = viewport.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();

      return itemRect.left + itemRect.width / 2 - (viewportRect.left + viewportRect.width / 2);
    };

    const isSettledOnIndex = (index, threshold = 1.5) =>
      Math.abs(getCenterDelta(index)) <= threshold;

    const getScrollLeftForCenteredItem = (index) => viewport.scrollLeft + getCenterDelta(index);

    const getActiveItemIndex = () => getClosestItemIndex();

    const getRealIndex = () => {
      const items = getItems();
      const activeIndex = getActiveItemIndex();
      const item = items[activeIndex];
      const slideIndex = Number(item?.dataset.ecDropSlide);
      return Number.isNaN(slideIndex) ? 0 : slideIndex;
    };

    const updateUi = (options = {}) => {
      const { allowVisualUpdate = true } = options;
      const items = getItems();
      if (!items.length) return;

      const viewportRect = viewport.getBoundingClientRect();
      const viewportCenter = viewportRect.left + viewportRect.width / 2;
      let activeIndex = 0;
      let minDist = Infinity;

      items.forEach((item, index) => {
        const itemRect = item.getBoundingClientRect();
        const itemCenter = itemRect.left + itemRect.width / 2;
        const dist = Math.abs(itemCenter - viewportCenter);

        if (dist < minDist) {
          minDist = dist;
          activeIndex = index;
        }
      });

      const freezeVisuals =
        !allowVisualUpdate ||
        viewport.classList.contains('is-user-scrolling') ||
        isTouchActive ||
        isUserScrolling ||
        isDragging;

      if (freezeVisuals) {
        return;
      }

      items.forEach((item) => {
        item.style.setProperty('--ec-drop-card-scale', '1');
        item.style.removeProperty('--ec-drop-card-brightness');
        item.style.removeProperty('--ec-drop-card-opacity');
      });

      items.forEach((item, index) => {
        item.classList.toggle('is-active', index === activeIndex);
      });

      const activeItem = items[activeIndex];
      const slideIndex = Number(activeItem?.dataset.ecDropSlide);
      const realIndex = Number.isNaN(slideIndex) ? 0 : slideIndex;

      dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', index === realIndex ? 'true' : 'false');
      });
    };

    const settleFlatGalleryUi = () => {
      viewport.classList.remove('is-user-scrolling');
      updateUi({ allowVisualUpdate: true });
    };

    const snapToClosestCenter = (behavior = 'smooth') => {
      if (isInitializing || isLoopAdjusting || isDragging || pendingDrag) return;

      const closest = getClosestItemIndex();
      const snapBehavior = prefersReducedMotion ? 'auto' : behavior;
      scrollToItemIndex(closest, snapBehavior);
    };

    const ensureAutoScrollTarget = () => {
      const items = getItems();

      if (autoScrollTargetIndex == null || !items[autoScrollTargetIndex]) {
        autoScrollTargetIndex = getClosestItemIndex() + 1;
      }

      if (autoScrollTargetIndex >= items.length) {
        autoScrollTargetIndex = getRealSetStartIndex();
      }
    };

    const advanceAutoScrollTarget = () => {
      normalizeLoopIfNeeded(true);
      autoScrollTargetIndex = getClosestItemIndex() + 1;
      ensureAutoScrollTarget();
    };

    const canAdjustLoop = () => !isInitializing && !isLoopAdjusting;

    const applyLoopJump = (jumpDelta) => {
      if (!jumpDelta) return 0;

      isLoopAdjusting = true;
      programmaticScrollDepth += 1;
      autoScrollTick = true;

      viewport.scrollLeft += jumpDelta;

      if (isDragging) {
        dragScrollLeft += jumpDelta;
      }

      if (autoScrollTargetIndex != null) {
        autoScrollTargetIndex = normalizeItemIndex(autoScrollTargetIndex);
      }

      window.requestAnimationFrame(() => {
        isLoopAdjusting = false;
        programmaticScrollDepth = Math.max(0, programmaticScrollDepth - 1);
        if (programmaticScrollDepth === 0) {
          autoScrollTick = false;
        }

        if (!viewport.classList.contains('is-user-scrolling') && !isDragging && !isUserScrolling) {
          updateUi();
        }
      });

      return jumpDelta;
    };

    const normalizeLoopIfNeeded = (requireSettled = true) => {
      if (originalCount <= 1 || !canAdjustLoop()) return 0;

      const closest = getClosestItemIndex();
      if (requireSettled && !isSettledOnIndex(closest)) return 0;
      if (isInRealZone(closest)) return 0;

      const normalizedIndex = normalizeItemIndex(closest);
      const jumpDelta = getScrollLeftForCenteredItem(normalizedIndex) - viewport.scrollLeft;

      if (Math.abs(jumpDelta) < 0.5) return 0;

      return applyLoopJump(jumpDelta);
    };

    const adjustScrollLoopIfNeeded = () => {
      if (originalCount <= 1 || !canAdjustLoop()) return;

      const setWidth = getSetWidth();
      const realStartOffset = getRealSetStartOffset();
      if (setWidth <= 0 || realStartOffset <= 0) return;

      const minScroll = realStartOffset - setWidth * 0.2;
      const maxScroll = realStartOffset + setWidth * 1.2;

      if (viewport.scrollLeft < minScroll) {
        applyLoopJump(setWidth);
      } else if (viewport.scrollLeft > maxScroll) {
        applyLoopJump(-setWidth);
      }
    };

    const adjustLoopIfNeeded = () => normalizeLoopIfNeeded(false);

    const settleAfterUserScroll = () => {
      if (isDragging || pendingDrag || isPointerActive || isTouchActive || isMomentumScrolling) return;

      clearTimeout(userScrollIdleTimeout);
      isUserScrolling = false;
      adjustScrollLoopIfNeeded();
      normalizeLoopIfNeeded(true);
      autoScrollTargetIndex = null;

      const closest = getClosestItemIndex();
      if (!isSettledOnIndex(closest, 6)) {
        snapToClosestCenter('smooth');
        return;
      }

      settleFlatGalleryUi();
    };

    const handleScroll = () => {
      if (isInitializing) return;

      if (autoScrollActive || isProgrammaticScroll() || isSmoothSnapping || isMomentumScrolling) return;

      adjustScrollLoopIfNeeded();

      viewport.classList.add('is-user-scrolling');
      onUserInteraction();
      isUserScrolling = true;
      clearTimeout(userScrollIdleTimeout);

      const idleMs = isTouchActive ? FLAT_GALLERY_TOUCH_IDLE_MS : FLAT_GALLERY_SCROLL_IDLE_MS;
      userScrollIdleTimeout = window.setTimeout(() => {
        isUserScrolling = false;
        settleAfterUserScroll();
      }, idleMs);
    };

    const pauseAutoScroll = () => {
      autoScrollActive = false;
      isAutoScrollMoving = false;
      markInitialAutoScrollComplete();
      viewport.classList.remove('is-auto-scrolling');
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    };

    const startAutoScroll = () => {
      if (prefersReducedMotion || originalCount <= 1 || document.hidden) return;
      if (isPointerActive || isTouchActive || isUserScrolling || isDragging) return;

      autoScrollTargetIndex = getClosestItemIndex() + 1;
      ensureAutoScrollTarget();
      autoScrollStartedAt = performance.now();
      autoScrollActive = true;
      viewport.classList.add('is-auto-scrolling');
      if (!rafId) tick();
    };

    const scheduleResume = () => {
      clearTimeout(resumeTimeout);
      if (prefersReducedMotion || originalCount <= 1) return;

      resumeTimeout = window.setTimeout(() => {
        if (!isPointerActive && !isTouchActive && !isUserScrolling && !isDragging) {
          startAutoScroll();
        }
      }, RESUME_DELAY_MS);
    };

    const onUserInteraction = () => {
      pauseAutoScroll();
      clearTimeout(resumeTimeout);
      scheduleResume();
    };

    const scrollToItemIndex = (index, behavior = 'auto') => {
      const items = getItems();
      const item = items[index];
      if (!item) return;

      const delta = getCenterDelta(index);
      const nextLeft = viewport.scrollLeft + delta;
      const effectiveBehavior = prefersReducedMotion ? 'auto' : behavior;

      if (effectiveBehavior === 'smooth') {
        animateScrollTo(nextLeft, () => {
          normalizeLoopIfNeeded(true);
          adjustScrollLoopIfNeeded();
          settleFlatGalleryUi();
        });
        return;
      }

      cancelManualScrollAnimations();
      runProgrammaticScroll(() => {
        viewport.scrollLeft = nextLeft;
      });
    };

    const scrollToRealIndex = (realIndex, behavior = 'smooth') => {
      scrollToItemIndex(getRealSetStartIndex() + realIndex, behavior);
    };

    const scrollByOneCard = (direction) => {
      const closest = getClosestItemIndex();
      const realStart = getRealSetStartIndex();
      const realEnd = getRealSetEndIndex();
      let targetIndex = closest + direction;

      if (direction > 0 && closest === realEnd - 1) {
        targetIndex = realEnd;
      } else if (direction < 0 && closest === realStart) {
        targetIndex = realStart - 1;
      }

      onUserInteraction();
      autoScrollTargetIndex = null;
      scrollToItemIndex(targetIndex, prefersReducedMotion ? 'auto' : 'smooth');
    };

    const moveTowardAutoScrollTarget = () => {
      const speed = getAutoScrollSpeed();

      isAutoScrollMoving = true;
      runProgrammaticScroll(() => {
        viewport.scrollLeft += speed;
      });
      isAutoScrollMoving = false;

      adjustScrollLoopIfNeeded();
      return false;
    };

    const tick = () => {
      rafId = null;

      if (!autoScrollActive || document.hidden) return;

      if (isPointerActive || isTouchActive || isUserScrolling || isDragging) {
        rafId = requestAnimationFrame(tick);
        return;
      }

      moveTowardAutoScrollTarget();
      updateUi();

      rafId = requestAnimationFrame(tick);
    };

    const waitsForLayoutReflow = document.body.classList.contains('template-index');
    let reflowInitFallback = null;

    const finishSliderInit = () => {
      if (!isInitializing) return;
      isInitializing = false;
      if (reflowInitFallback) {
        clearTimeout(reflowInitFallback);
        reflowInitFallback = null;
      }
      startAutoScroll();
    };

    const alignSlider = (preserveRealIndex = false) => {
      if (preserveRealIndex) {
        scrollToRealIndex(getRealIndex(), 'auto');
      } else {
        scrollToItemIndex(getRealSetStartIndex(), 'auto');
      }

      autoScrollTargetIndex = getClosestItemIndex() + 1;
      ensureAutoScrollTarget();
      adjustScrollLoopIfNeeded();
      updateUi();
    };

    const handleLayoutReflow = () => {
      if (isDragging || isLoopAdjusting || isPointerActive || window.scrollY > 48) return;

      const wasInitializing = isInitializing;
      alignSlider(!wasInitializing);
      if (wasInitializing) {
        finishSliderInit();
      } else if (!autoScrollActive && !document.hidden && !prefersReducedMotion) {
        startAutoScroll();
      }
    };

    const scheduleLayoutReflow = () => {
      if (window.scrollY > 48) return;

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(handleLayoutReflow);
      });
    };

    const initSlider = () => {
      alignSlider(false);
      window.requestAnimationFrame(() => {
        alignSlider(false);
        if (!waitsForLayoutReflow) {
          finishSliderInit();
        }
      });

      if (waitsForLayoutReflow) {
        reflowInitFallback = window.setTimeout(finishSliderInit, 800);
      }

      track.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', () => alignSlider(!isInitializing), { once: true });
        if (image.decode) {
          image.decode().catch(() => {});
        }
      });
    };

    section.addEventListener('ec-drop-slider-reflow', handleLayoutReflow);

    prevButton?.addEventListener('click', () => scrollByOneCard(-1));
    nextButton?.addEventListener('click', () => scrollByOneCard(1));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const targetIndex = Number(dot.dataset.ecDropDot);
        if (Number.isNaN(targetIndex)) return;
        onUserInteraction();
        scrollToRealIndex(targetIndex, 'smooth');
      });
    });

    viewport.addEventListener(
      'mouseenter',
      () => {
        isHovered = true;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'mouseleave',
      () => {
        isHovered = false;
      },
      { passive: true }
    );

    viewport.addEventListener('mousedown', onUserInteraction);

    viewport.addEventListener(
      'touchstart',
      () => {
        cancelManualScrollAnimations();
        isTouchActive = true;
        viewport.classList.add('is-user-scrolling');
        onUserInteraction();
      },
      { passive: true }
    );

    viewport.addEventListener(
      'wheel',
      () => {
        isTouchActive = false;
        onUserInteraction();
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchcancel',
      () => {
        isTouchActive = false;
        settleFlatGalleryUi();
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      () => {
        isTouchActive = false;
        onUserInteraction();
        clearTimeout(userScrollIdleTimeout);
        userScrollIdleTimeout = window.setTimeout(() => {
          isUserScrolling = false;
          settleAfterUserScroll();
        }, FLAT_GALLERY_TOUCH_IDLE_MS);
      },
      { passive: true }
    );

    viewport.addEventListener('scroll', handleScroll, { passive: true });

    viewport.addEventListener(
      'pointerdown',
      (event) => {
        if (event.pointerType === 'touch') return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        cancelManualScrollAnimations();
        isPointerActive = true;
        onUserInteraction();
        pendingDrag = true;
        isDragging = false;
        dragDistance = 0;
        dragVelocity = 0;
        lastDragX = event.clientX;
        lastDragTime = performance.now();
        dragStartX = event.clientX;
        dragScrollLeft = viewport.scrollLeft;
        activePointerId = event.pointerId;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'pointermove',
      (event) => {
        if (!pendingDrag && !isDragging) return;
        if (activePointerId != null && event.pointerId !== activePointerId) return;

        const delta = event.clientX - dragStartX;
        dragDistance = Math.max(dragDistance, Math.abs(delta));

        if (!isDragging && Math.abs(delta) > 8) {
          isDragging = true;
          pendingDrag = false;
          viewport.classList.add('is-dragging', 'is-user-scrolling');
          viewport.setPointerCapture(event.pointerId);
        }

        if (!isDragging) return;

        const now = performance.now();
        const elapsed = now - lastDragTime;

        if (elapsed > 0) {
          dragVelocity = (event.clientX - lastDragX) / elapsed;
        }

        lastDragX = event.clientX;
        lastDragTime = now;
        viewport.scrollLeft = dragScrollLeft - delta;
        adjustScrollLoopIfNeeded();
      },
      { passive: true }
    );

    const endDrag = (event) => {
      if (activePointerId != null && event?.pointerId != null && event.pointerId !== activePointerId) {
        return;
      }

      const wasDragging = isDragging;
      pendingDrag = false;
      isPointerActive = false;
      activePointerId = null;

      if (wasDragging) {
        isDragging = false;
        viewport.classList.remove('is-dragging');
        if (event?.pointerId != null && viewport.hasPointerCapture(event.pointerId)) {
          viewport.releasePointerCapture(event.pointerId);
        }

        isUserScrolling = true;
        clearTimeout(userScrollIdleTimeout);
        releaseDragMomentum();
      }

      onUserInteraction();
    };

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    viewport.addEventListener(
      'click',
      (event) => {
        if (dragDistance > 8) {
          event.preventDefault();
          event.stopPropagation();
        }
        dragDistance = 0;
      },
      true
    );

    viewport.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollByOneCard(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollByOneCard(1);
      }
    });

    if ('onscrollend' in viewport) {
      viewport.addEventListener(
        'scrollend',
        () => {
          isSmoothSnapping = false;

          if (
            isInitializing ||
            autoScrollActive ||
            isProgrammaticScroll() ||
            isDragging ||
            isPointerActive ||
            isUserScrolling
          ) {
            return;
          }

          normalizeLoopIfNeeded(true);
          adjustScrollLoopIfNeeded();
          settleFlatGalleryUi();
        },
        { passive: true }
      );
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        pauseAutoScroll();
      } else {
        scheduleResume();
      }
    });

    let resizeFrame = null;
    let lastViewportWidth = viewport.clientWidth;
    const resizeObserver = new ResizeObserver((entries) => {
      if (isDragging || isLoopAdjusting || isTouchActive || window.scrollY > 48) return;

      const entry = entries[0];
      const nextWidth = entry?.contentRect?.width || viewport.clientWidth;
      const widthDelta = Math.abs(nextWidth - lastViewportWidth);
      const minResizeDelta = 12;

      if (widthDelta < minResizeDelta) return;

      lastViewportWidth = nextWidth;

      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(scheduleLayoutReflow);
    });
    resizeObserver.observe(viewport);

    window.addEventListener('orientationchange', () => {
      lastViewportWidth = 0;
      window.setTimeout(scheduleLayoutReflow, 250);
    });

    if (document.fonts?.ready) {
      document.fonts.ready.then(initSlider);
    } else {
      window.requestAnimationFrame(initSlider);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-product-main"]) return;
  try {
    
  const productSection = document.querySelector('.ec-product');
  if (!productSection) return;

  const productData = JSON.parse(
    productSection.querySelector('[data-ec-product-json]').textContent
  );
  const variantInput = productSection.querySelector('[data-ec-variant-id]');
  const priceEl = productSection.querySelector('[data-ec-product-price]');
  const addToCartBtn = productSection.querySelector('[data-ec-add-to-cart]');
  const mainImage = productSection.querySelector('#ec-product-main-image');
  const mainMedia = productSection.querySelector('[data-ec-main-media]');
  const productGallery = productSection.querySelector('[data-ec-product-gallery]');
  const productChart = productSection.querySelector('.ec-product__size-chart-row');
  const productPurchase = productSection.querySelector('.ec-product__purchase');
  const productBuyPanel = productSection.querySelector('.ec-product__buy-panel');
  const productDetails = productSection.querySelector('.ec-product__details');
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const tabletPortraitQuery = window.matchMedia('(min-width: 750px) and (max-width: 1199px) and (orientation: portrait)');
  const mobileLandscapeQuery = window.matchMedia('(max-width: 749px) and (orientation: landscape) and (max-height: 32rem)');
  const galleryDots = productSection.querySelectorAll('[data-ec-gallery-dot]');
  const galleryPrev = productSection.querySelector('[data-ec-gallery-prev]');
  const galleryNext = productSection.querySelector('[data-ec-gallery-next]');
  const galleryJsonEl = productSection.querySelector('[data-ec-gallery-json]');
  const galleryItems = galleryJsonEl ? JSON.parse(galleryJsonEl.textContent) : [];
  let activeGalleryIndex = 0;
  let syncGalleryFrame = 0;
  const currency = priceEl?.dataset.currency || 'USD';

  const formatMoney = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency,
    }).format(cents / 100);

  const measureCollapsedGalleryStackHeight = () => {
    const productTitle = productSection.querySelector('.ec-product__title');
    const heading = productSection.querySelector('.ec-product__heading');
    const stackAnchor = productTitle || heading;

    if (!stackAnchor || !productDetails) return null;

    const stackTop = stackAnchor.getBoundingClientRect().top;
    const accordionItems = productDetails.querySelectorAll('.ec-accordion__item');
    const openStates = [...accordionItems].map((item) => item.open);

    accordionItems.forEach((item) => {
      item.open = false;
    });

    const stackHeight = Math.ceil(productDetails.getBoundingClientRect().bottom - stackTop);

    openStates.forEach((wasOpen, index) => {
      accordionItems[index].open = wasOpen;
    });

    return stackHeight > 0 ? stackHeight : null;
  };

  const syncProductGalleryLayout = () => {
    if (!productGallery || !mainMedia) return;

    mainMedia.style.height = '';
    mainMedia.style.minHeight = '';
    productGallery.style.height = '';
    productGallery.style.minHeight = '';
    productGallery.style.marginTop = '';

    if (mobileLandscapeQuery.matches) {
      const title = productSection.querySelector('.ec-product__title');
      const purchase = productSection.querySelector('.ec-product__purchase');

      if (!title || !purchase) return;

      const titleTop = title.getBoundingClientRect().top;
      const galleryTop = productGallery.getBoundingClientRect().top;
      const topOffset = Math.max(0, Math.round(titleTop - galleryTop));
      const stackHeight = Math.ceil(purchase.getBoundingClientRect().bottom - titleTop);

      if (stackHeight > 0) {
        if (topOffset > 0) {
          productGallery.style.marginTop = `${topOffset}px`;
        }

        mainMedia.style.height = `${stackHeight}px`;
        mainMedia.style.minHeight = `${stackHeight}px`;
        productGallery.style.height = `${stackHeight}px`;
        productGallery.style.minHeight = `${stackHeight}px`;
      }

      return;
    }

    if (desktopQuery.matches || tabletPortraitQuery.matches) {
      const productTitle = productSection.querySelector('.ec-product__title');
      const heading = productSection.querySelector('.ec-product__heading');
      const stackAnchor = productTitle || heading;

      if (!stackAnchor || !productDetails) return;

      const stackTop = stackAnchor.getBoundingClientRect().top;
      const stackHeight = measureCollapsedGalleryStackHeight();
      const galleryTop = productGallery.getBoundingClientRect().top;
      const topOffset = Math.max(0, Math.round(stackTop - galleryTop));

      if (stackHeight > 0) {
        if (topOffset > 0) {
          productGallery.style.marginTop = `${topOffset}px`;
        }

        mainMedia.style.height = `${stackHeight}px`;
        mainMedia.style.minHeight = `${stackHeight}px`;
        productGallery.style.height = `${stackHeight}px`;
        productGallery.style.minHeight = `${stackHeight}px`;
      }
    }
  };

  const scheduleGalleryLayoutSync = () => {
    cancelAnimationFrame(syncGalleryFrame);
    syncGalleryFrame = requestAnimationFrame(syncProductGalleryLayout);
  };

  scheduleGalleryLayoutSync();
  window.addEventListener('resize', scheduleGalleryLayoutSync, { passive: true });
  desktopQuery.addEventListener('change', scheduleGalleryLayoutSync);
  tabletPortraitQuery.addEventListener('change', scheduleGalleryLayoutSync);
  mobileLandscapeQuery.addEventListener('change', scheduleGalleryLayoutSync);

  if (typeof ResizeObserver !== 'undefined') {
    const galleryLayoutObserver = new ResizeObserver(scheduleGalleryLayoutSync);
    const productHeading = productSection.querySelector('.ec-product__heading');
    const shopCheckout = productSection.querySelector('.ec-product__wallet-checkout--shop');
    const dynamicCheckout = productSection.querySelector('[data-ec-dynamic-checkout]');

    [productHeading, productPurchase, productChart, productBuyPanel, shopCheckout, dynamicCheckout].forEach((block) => {
      if (block) galleryLayoutObserver.observe(block);
    });

    if (productPurchase) {
      const purchaseObserver = new MutationObserver(scheduleGalleryLayoutSync);
      purchaseObserver.observe(productPurchase, { childList: true, subtree: true, attributes: true });
    }
  }

  if (mainImage) {
    if (mainImage.complete) {
      scheduleGalleryLayoutSync();
    } else {
      mainImage.addEventListener('load', scheduleGalleryLayoutSync, { once: true });
    }
  }

  window.setTimeout(scheduleGalleryLayoutSync, 400);
  window.setTimeout(scheduleGalleryLayoutSync, 1200);

  const getActiveGalleryIndex = () => activeGalleryIndex;

  const updateGalleryControls = (index) => {
    activeGalleryIndex = index;

    galleryDots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (galleryPrev) {
      galleryPrev.disabled = index <= 0;
    }

    if (galleryNext) {
      galleryNext.disabled = index >= galleryItems.length - 1;
    }
  };

  const setMainImageByIndex = (index) => {
    const item = galleryItems[index];
    if (!mainImage || !item?.src) return;

    mainImage.classList.add('is-swapping');
    mainImage.removeAttribute('srcset');
    mainImage.src = item.src;

    if (item.srcset) {
      mainImage.srcset = item.srcset;
    }

    mainImage.dataset.mediaId = String(item.id);
    updateGalleryControls(index);

    const revealImage = () => {
      mainImage.classList.remove('is-swapping');
    };

    if (mainImage.complete) {
      requestAnimationFrame(revealImage);
    } else {
      mainImage.addEventListener('load', revealImage, { once: true });
    }
  };

  const goToGalleryIndex = (index) => {
    if (index < 0 || index >= galleryItems.length) return;
    setMainImageByIndex(index);
  };

  if (mainImage && galleryItems.length) {
    const initialIndex = galleryItems.findIndex(
      (item) => String(item.id) === String(mainImage.dataset.mediaId)
    );
    activeGalleryIndex = initialIndex >= 0 ? initialIndex : 0;
    updateGalleryControls(activeGalleryIndex);
  }

  const productForm = productSection.querySelector('[data-ec-product-form]');
  const useSizeVariants = productForm?.dataset.ecUseSizeVariants === 'true';

  const findVariant = () => {
    const selectedOptions = [];
    productSection.querySelectorAll('[data-ec-option-input]:checked').forEach((input) => {
      const index = parseInt(input.dataset.optionIndex, 10);
      if (!Number.isNaN(index) && input.value) {
        selectedOptions[index] = input.value;
      }
    });

    if (selectedOptions.length > 0) {
      const matchedVariant = productData.variants.find((variant) =>
        variant.options.every((option, index) => option === selectedOptions[index])
      );

      if (matchedVariant) {
        return matchedVariant;
      }
    }

    if (!useSizeVariants) {
      return (
        productData.variants.find((variant) => variant.id === Number(variantInput.value)) ||
        productData.variants[0]
      );
    }

    return null;
  };

  const syncAcceleratedCheckoutVariant = (variant) => {
    if (!variant || !variantInput) return;

    variantInput.value = variant.id;
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));

    const nextParams = JSON.stringify([
      { id: variant.id, requiresShipping: variant.requires_shipping !== false },
    ]);

    productSection.querySelectorAll('shopify-accelerated-checkout').forEach((acceleratedCheckout) => {
      if (acceleratedCheckout.getAttribute('variant-params') === nextParams) return;
      acceleratedCheckout.setAttribute('variant-params', nextParams);
    });
  };

  const moveMoreOptionsToSlot = () => {
    const checkoutWrap = productSection.querySelector('[data-ec-dynamic-checkout]');
    const moreOptionsSlot = checkoutWrap?.querySelector('[data-ec-more-options-slot]');
    const shopWrap = checkoutWrap?.querySelector('.ec-product__wallet-checkout--shop');
    const moreOptions = shopWrap?.querySelector('.shopify-payment-button__more-options');

    if (!checkoutWrap || !moreOptionsSlot) return;

    if (moreOptions) {
      if (moreOptions.parentElement !== moreOptionsSlot) {
        moreOptionsSlot.appendChild(moreOptions);
      }
      moreOptionsSlot.hidden = false;
      return;
    }

    moreOptionsSlot.hidden = moreOptionsSlot.childElementCount === 0;
  };

  const updateVariant = () => {
    const variant = findVariant();
    if (!variant) return;

    syncAcceleratedCheckoutVariant(variant);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceEl.innerHTML = `
        <span class="ec-product__price-sale">${formatMoney(variant.price)}</span>
        <span class="ec-product__price-compare">${formatMoney(variant.compare_at_price)}</span>
      `;
    } else {
      priceEl.textContent = formatMoney(variant.price);
    }

    if (addToCartBtn) {
      addToCartBtn.disabled = !variant.available;
      addToCartBtn.textContent = variant.available
        ? addToCartBtn.dataset.labelAvailable
        : addToCartBtn.dataset.labelSoldOut;
    }

    if (variant.featured_media) {
      const matchIndex = galleryItems.findIndex(
        (item) => String(item.id) === String(variant.featured_media.id)
      );

      if (matchIndex >= 0) {
        setMainImageByIndex(matchIndex);
      }
    }
  };

  productSection.querySelectorAll('[data-ec-option-input]').forEach((input) => {
    input.addEventListener('change', updateVariant);
  });

  const sizeFields = productSection.querySelector('[data-ec-size-fields]');

  const setSizeGroupSelection = (selectedInput) => {
    if (!sizeFields || !selectedInput) return;

    const group = selectedInput.dataset.ecSizeGroup;
    if (!group) return;

    sizeFields.querySelectorAll(`[data-ec-size-group="${group}"]`).forEach((input) => {
      const isSelected = input === selectedInput;
      input.checked = isSelected;
      input.closest('.ec-product__option-value--size')?.classList.toggle('is-selected', isSelected);
    });

    if (selectedInput.hasAttribute('data-ec-option-input')) {
      updateVariant();
    }
  };

  if (sizeFields) {
    sizeFields.addEventListener('click', (event) => {
      const label = event.target.closest('label.ec-product__option-value--size');
      if (!label || label.classList.contains('is-unavailable')) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input || input.disabled) return;

      event.preventDefault();
      setSizeGroupSelection(input);
    });

    sizeFields.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
      input.closest('.ec-product__option-value--size')?.classList.add('is-selected');
    });
  }

  updateVariant();

  galleryDots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      goToGalleryIndex(index);
    });
  });

  galleryPrev?.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    goToGalleryIndex(getActiveGalleryIndex() - 1);
  });

  galleryNext?.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    goToGalleryIndex(getActiveGalleryIndex() + 1);
  });

  if (mainMedia && galleryItems.length > 1) {
    let touchStartX = 0;

    mainMedia.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].clientX;
      },
      { passive: true }
    );

    mainMedia.addEventListener(
      'touchend',
      (event) => {
        const touchEndX = event.changedTouches[0].clientX;
        const distance = touchEndX - touchStartX;

        if (Math.abs(distance) < 40) return;

        if (distance < 0) {
          goToGalleryIndex(getActiveGalleryIndex() + 1);
        } else {
          goToGalleryIndex(getActiveGalleryIndex() - 1);
        }
      },
      { passive: true }
    );
  }

  const customizeBuyNowButton = () => {
    const checkoutWrap = productSection.querySelector('[data-ec-dynamic-checkout]');
    if (!checkoutWrap) return;

    const buyNowLabel = checkoutWrap.dataset.buyNowLabel || 'Buy now';
    const buyNowButton = checkoutWrap.querySelector('.shopify-payment-button__button--unbranded');

    if (buyNowButton && !buyNowButton.dataset.ecCustomized) {
      buyNowButton.dataset.ecCustomized = 'true';
      buyNowButton.textContent = buyNowLabel.toUpperCase();
      buyNowButton.setAttribute('aria-label', buyNowLabel);
    }
  };

  const scheduleCheckoutSync = () => {
    customizeBuyNowButton();
    moveMoreOptionsToSlot();
    scheduleGalleryLayoutSync();
  };

  scheduleCheckoutSync();
  [300, 1200, 3000].forEach((delay) => {
    window.setTimeout(scheduleCheckoutSync, delay);
  });

  const checkoutObserver = new MutationObserver(() => {
    scheduleCheckoutSync();

    const variant = findVariant();
    if (variant) {
      syncAcceleratedCheckoutVariant(variant);
    }
  });

  const checkoutWrap = productSection.querySelector('[data-ec-dynamic-checkout]');
  if (checkoutWrap) {
    checkoutObserver.observe(checkoutWrap, { childList: true, subtree: true });
  }

  const updateHeaderCartCount = async () => {
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return;

      const cart = await response.json();
      const cartButton = document.querySelector('.site-header__cart');
      if (!cartButton) return;

      let countBadge = cartButton.querySelector('.site-header__cart-count');

      if (cart.item_count > 0) {
        if (!countBadge) {
          countBadge = document.createElement('sup');
          countBadge.className = 'site-header__cart-count';
          cartButton.appendChild(countBadge);
        }
        countBadge.textContent = String(cart.item_count);
      } else if (countBadge) {
        countBadge.remove();
      }
    } catch (error) {
      /* ignore */
    }
  };

  productForm?.addEventListener('submit', async (event) => {
    const submitter = event.submitter;

    if (submitter && !submitter.hasAttribute('data-ec-add-to-cart')) {
      return;
    }

    event.preventDefault();

    if (!addToCartBtn || addToCartBtn.disabled) return;

    const formData = new FormData(productForm);
    const variantId = Number(formData.get('id'));
    const quantity = Number(formData.get('quantity')) || 1;

    if (!variantId) return;

    const item = { id: variantId, quantity };
    const properties = {};
    let rashguardProperty =
      formData.get('properties[Size - Rashguard]') || formData.get('properties[Size]');

    if (!rashguardProperty) {
      const rashguardInput = productForm.querySelector('[data-ec-rashguard-size-input]:checked');
      if (rashguardInput) {
        rashguardProperty = rashguardInput.value;
      }
    }

    const shortsProperty = formData.get('properties[Size - Compression Shorts]');

    if (rashguardProperty) {
      properties['Size - Rashguard'] = rashguardProperty;
    }

    if (shortsProperty) {
      properties['Size - Compression Shorts'] = shortsProperty;
    }

    if (Object.keys(properties).length > 0) {
      item.properties = properties;
    }

    addToCartBtn.disabled = true;
    const originalLabel = addToCartBtn.textContent;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] }),
      });

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      addToCartBtn.textContent = addToCartBtn.dataset.labelAdded || 'Added';
      await updateHeaderCartCount();

      if (typeof window.ecOpenCartDrawer === 'function') {
        await window.ecOpenCartDrawer();
      } else if (typeof window.ecRefreshCartDrawer === 'function') {
        await window.ecRefreshCartDrawer();
      }

      window.setTimeout(() => {
        updateVariant();
        addToCartBtn.textContent = originalLabel;
      }, 1600);
    } catch (error) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = originalLabel;
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('.site-header');
  if (!header) return;

  const toggle = header.querySelector('.site-header__menu-toggle');
  const drawer = header.querySelector('.site-header__drawer');
  const closeButton = header.querySelector('.site-header__drawer-close');
  const backdrop = header.querySelector('.site-header__backdrop');

  const openDrawer = () => {
    drawer.hidden = false;
    backdrop.hidden = false;
    header.classList.add('site-header--menu-open');
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
    });
    toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    header.classList.remove('site-header--menu-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    window.setTimeout(() => {
      drawer.hidden = true;
      backdrop.hidden = true;
    }, 300);
  };

  toggle?.addEventListener('click', openDrawer);
  closeButton?.addEventListener('click', closeDrawer);
  backdrop?.addEventListener('click', closeDrawer);

  drawer?.querySelectorAll('a, [data-ec-open-cart-drawer]').forEach((link) => {
    link.addEventListener('click', () => {
      closeDrawer();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
